module.exports = __webpack_public_path__ + "f07eb6da3d143a337eb535b3fb853616.png";